<template>
  <div class="home">
    <!-- Premium Header Area -->
    <div class="header">
      <div class="header-bg"></div>
      
      <div class="title-wrapper">
        <h1 class="title">网红打榜助力</h1>
        <p class="subtitle">STAR INFLUENCER RANKING</p>
      </div>
      
      <!-- Leaderboard (Top 3) -->
      <div class="rank">
        <!-- Rank 2 -->
        <div class="rank-item rank-2" v-if="top3[1]" @click="goAbout(top3[1])">
          <div class="avatar-wrap">
            <img :src="top3[1].img" :alt="top3[1].name" class="avatar" />
            <div class="frame silver"></div>
            <div class="rank-badge silver-badge">2</div>
          </div>
          <div class="name">{{ top3[1].name }}</div>
          <div class="score">{{ top3[1].score.replace('助力积分：', '') }}</div>
        </div>
        
        <!-- Rank 1 -->
        <div class="rank-item rank-1" v-if="top3[0]" @click="goAbout(top3[0])">
          <div class="avatar-wrap">
            <img :src="top3[0].img" :alt="top3[0].name" class="avatar" />
            <div class="frame gold"></div>
            <div class="rank-badge gold-badge">1</div>
          </div>
          <div class="name">{{ top3[0].name }}</div>
          <div class="score">{{ top3[0].score.replace('助力积分：', '') }}</div>
        </div>
        
        <!-- Rank 3 -->
        <div class="rank-item rank-3" v-if="top3[2]" @click="goAbout(top3[2])">
          <div class="avatar-wrap">
            <img :src="top3[2].img" :alt="top3[2].name" class="avatar" />
            <div class="frame bronze"></div>
            <div class="rank-badge bronze-badge">3</div>
          </div>
          <div class="name">{{ top3[2].name }}</div>
          <div class="score">{{ top3[2].score.replace('助力积分：', '') }}</div>
        </div>
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">人气主播列表</h2>
        <span class="section-count">共 {{ list.length }} 名主播</span>
      </div>
      
      <transition-group name="list-anim" tag="div" class="list">
        <div
          class="list-item"
          v-for="(item, index) in list"
          :key="item.id || index"
          @click="goAbout(item)"
        >
          <div class="item-rank" :class="{'top-rank': index + 4 <= 10}">
            {{ index + 4 }}
          </div>
          
          <div class="item-avatar-wrap">
            <img :src="item.img" :alt="item.name" class="item-avatar" />
          </div>
          
          <div class="item-content">
            <div class="item-name">{{ item.name }}</div>
            <div class="item-score">
              <i class="fire-icon"></i>
              <span class="score-number">{{ item.score.replace('助力积分：', '') }}</span>
            </div>
          </div>
          
          <div class="item-action">
            <button class="boost-btn">助力</button>
          </div>
        </div>
      </transition-group>
    </div>

    <!-- Auto Login Toast -->
    <transition name="fade">
      <div v-if="showLoginToast" class="toast-wrapper">
        <div class="toast-content glass-panel">
          <div class="spinner"></div>
          <span class="toast-text">安全登录中...</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import data from "../assets/json/data.json";

export default {
  name: 'IndexPage',
  data() {
    return {
      list: [],
      top3: [],
      showLoginToast: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    goAbout(item) {
      localStorage.setItem("item", JSON.stringify(item));
      this.$router.push({ path: "/about" });
    },
    getList() {
      this.showLoginToast = true;
      setTimeout(() => {
        this.showLoginToast = false;
        
        let sourceList = [];
        let fromCache = false;
        if (localStorage.getItem("Images_v3")) {
          sourceList = JSON.parse(localStorage.getItem("Images_v3"));
          fromCache = true;
          // Recovery mechanism: if the list was corrupted/shrunk by the previous bug, reset it.
          if (!sourceList || sourceList.length < 50) {
            fromCache = false;
          }
        }
        
        if (!fromCache) {
          sourceList = data.list.map((item) => {
            let img;
            try {
              img = require("../assets/image/" + item.img);
            } catch (e) {
              console.warn("Missing image:", item.img);
              img = require("../assets/image/default_avatar.jpg");
            }
            return {
              ...item,
              img: img
            };
          });
        }
        
        // Process the FULL list from data.json
        const cleanedList = sourceList.map((item, index) => {
          const originalName = item.name || '';
          const cleanName = originalName.replace(/^\d+\./, '');
          
          let cleanText = item.text || '';
          if (cleanText.startsWith(cleanName + '：')) {
            cleanText = cleanText.substring(cleanName.length + 1).trim();
          } else if (cleanText.startsWith(cleanName + ':')) {
            cleanText = cleanText.substring(cleanName.length + 1).trim();
          }
          
          if (cleanText.startsWith(originalName + '：')) {
            cleanText = cleanText.substring(originalName.length + 1).trim();
          }

          return {
            ...item,
            name: cleanName,
            text: cleanText,
            rank: index + 1
          };
        });
        
        localStorage.setItem("Images_v3", JSON.stringify(cleanedList));
        
        this.top3 = cleanedList.slice(0, 3);
        this.list = cleanedList.slice(3);
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-body);
}

/* Header & Leaderboard */
.header {
  position: relative;
  padding-top: 40px;
  padding-bottom: 60px; /* More padding to allow container to overlap safely */
  z-index: 1;
}

.header-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* New Premium Indigo/Violet Color Tone */
  background: linear-gradient(135deg, #4338ca 0%, #7c3aed 100%);
  border-bottom-left-radius: 40px;
  border-bottom-right-radius: 40px;
  z-index: -1;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(124, 58, 237, 0.3);
  
  &::before {
    content: '';
    position: absolute;
    top: -30%;
    right: -10%;
    width: 250px;
    height: 250px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255,255,255,0.15) 0%, transparent 70%);
  }
}

.title-wrapper {
  text-align: center;
  margin-bottom: 30px;
  
  .title {
    font-size: 28px;
    font-weight: 900;
    color: #ffffff;
    letter-spacing: 2px;
    text-shadow: 0 4px 12px rgba(0,0,0,0.2);
    margin-bottom: 6px;
  }
  
  .subtitle {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 3px;
    color: rgba(255,255,255,0.7);
  }
}

.rank {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 0 15px;
  gap: 10px;
}

.rank-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  
  .avatar-wrap {
    position: relative;
    /* The wrapper defines the size of the whole frame block */
    display: flex;
    justify-content: center;
    align-items: flex-end; /* Align to bottom so avatar sits nicely */
    
    .frame {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      /* Frame is ON TOP of the avatar to hide rough edges */
      z-index: 3;
    }
    
    .avatar {
      border-radius: 50%;
      object-fit: cover;
      background: #fff;
      position: absolute;
      /* Avatar is BEHIND the frame */
      z-index: 2;
    }
    
    .rank-badge {
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      min-width: 22px;
      height: 22px;
      padding: 0 6px;
      border-radius: 11px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-weight: 900;
      color: #fff;
      border: 2px solid #fff;
      z-index: 4;
      box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    }
  }

  .name {
    font-size: 14px;
    font-weight: 800;
    color: #fff;
    margin-top: 16px;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  }
  
  .score {
    font-size: 11px;
    font-weight: 700;
    color: rgba(255,255,255,0.95);
    background: rgba(0,0,0,0.25);
    padding: 3px 10px;
    border-radius: 12px;
    backdrop-filter: blur(4px);
  }
}

/* Precise Avatar and Frame sizing */
.rank-1 {
  z-index: 2;
  transform: translateY(-15px);
  /* The frame image aspect ratio */
  .avatar-wrap { width: 100px; height: 133px; }
  /* The avatar size and position */
  .avatar { width: 78px; height: 78px; bottom: 12px; }
  .name { font-size: 16px; }
  .frame.gold { background-image: url('../assets/image/rank_1.14956bf9.png'); }
  .gold-badge { background: linear-gradient(135deg, #f59e0b, #d97706); }
}

.rank-2 {
  /* The frame image aspect ratio */
  .avatar-wrap { width: 76px; height: 97px; }
  /* The avatar size and position */
  .avatar { width: 62px; height: 62px; bottom: 8px; }
  .frame.silver { background-image: url('../assets/image/rank_2.1b53b9e6.png'); }
  .silver-badge { background: linear-gradient(135deg, #94a3b8, #64748b); }
}

.rank-3 {
  /* The frame image aspect ratio */
  .avatar-wrap { width: 76px; height: 97px; }
  /* The avatar size and position */
  .avatar { width: 62px; height: 62px; bottom: 8px; }
  .frame.bronze { background-image: url('../assets/image/rank_3.d47896b0.png'); }
  .bronze-badge { background: linear-gradient(135deg, #ef4444, #b91c1c); }
}

/* Container & List */
.container {
  flex: 1;
  /* Fix the overlap issue by giving the container a solid white background and pulling it up */
  background: var(--bg-card, #ffffff);
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  padding: 24px 16px 30px;
  position: relative;
  z-index: 2;
  margin-top: -30px;
  box-shadow: 0 -8px 24px rgba(0,0,0,0.06);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 4px;
  
  .section-title {
    font-size: 18px;
    font-weight: 800;
    color: var(--text-main, #1d1d1f);
  }
  
  .section-count {
    font-size: 13px;
    color: var(--text-secondary, #86868b);
    font-weight: 600;
  }
}

.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.list-item {
  display: flex;
  align-items: center;
  background: var(--bg-card, #ffffff);
  border-radius: var(--radius-md, 16px);
  padding: 12px 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.03);
  border: 1px solid rgba(0,0,0,0.02);
  transition: all 0.2s ease;
  cursor: pointer;
  
  &:active {
    transform: scale(0.98);
    background: #f8fafc;
  }
  
  .item-rank {
    width: 28px;
    font-size: 16px;
    font-weight: 800;
    color: #cbd5e1;
    text-align: left;
    font-style: italic;
    
    &.top-rank {
      color: #94a3b8;
    }
  }
  
  .item-avatar-wrap {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    box-shadow: 0 4px 10px rgba(0,0,0,0.08);
    border: 2px solid #fff;
    margin-right: 14px;
    
    .item-avatar {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .item-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    
    .item-name {
      font-size: 16px;
      font-weight: 800;
      color: var(--text-main, #1e293b);
      margin-bottom: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    .item-score {
      display: flex;
      align-items: center;
      gap: 4px;
      
      .fire-icon {
        width: 12px;
        height: 12px;
        background: #ef4444;
        mask: url('data:image/svg+xml;utf8,<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 11c0 3.5-2.5 6-5.5 6S6.5 14.5 6.5 11C6.5 6 12 2 12 2s5.5 4 5.5 9z"/></svg>') no-repeat center;
        -webkit-mask: url('data:image/svg+xml;utf8,<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.66 11.2c-.23-.3-.51-.56-.77-.82-.67-.6-1.43-1.03-2.07-1.66C13.33 7.26 13 4.85 13.95 3c-.95.23-1.78.75-2.49 1.32-2.59 2.08-3.61 5.75-2.39 8.9.04.1.08.2.08.33 0 .22-.15.42-.35.5-.22.1-.46.04-.56-.16h-.01c-.47-.74-.73-1.67-.7-2.65-.96 1.1-1.68 2.58-1.74 4.15-.06 1.7.53 3.39 1.63 4.63C8.61 21.43 10.23 22 12 22c3.31 0 6-2.69 6-6 0-1.74-.69-3.41-1.92-4.63-.12-.13-.25-.26-.42-.38z"/></svg>') no-repeat center;
      }
      
      .score-number {
        font-size: 13px;
        font-weight: 700;
        color: #ef4444;
      }
    }
  }
  
  .item-action {
    margin-left: 10px;
    
    .boost-btn {
      background: rgba(79, 70, 229, 0.1);
      color: #4f46e5;
      border: none;
      padding: 8px 16px;
      border-radius: 20px;
      font-size: 13px;
      font-weight: 800;
      cursor: pointer;
      transition: all 0.2s;
      
      &:active {
        background: rgba(79, 70, 229, 0.2);
        transform: scale(0.95);
      }
    }
  }
}

/* Animations */
.list-anim-enter-active, .list-anim-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.list-anim-enter, .list-anim-leave-to {
  opacity: 0;
  transform: translateY(15px);
}

/* Toast */
.toast-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background: rgba(255,255,255,0.6);
  backdrop-filter: blur(4px);
}

.toast-content {
  padding: 24px 32px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background: #fff;
  box-shadow: 0 10px 40px rgba(0,0,0,0.1);
  
  .spinner {
    width: 32px;
    height: 32px;
    border: 3px solid rgba(79, 70, 229, 0.1);
    border-radius: 50%;
    border-top-color: #4f46e5;
    animation: spin 0.8s linear infinite;
  }
  
  .toast-text {
    font-size: 14px;
    font-weight: 700;
    color: #1d1d1f;
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>